import React, { FC } from 'react';
import { TimePicker as MuiComponent, TimePickerProps as MuiProps } from '@mui/x-date-pickers/TimePicker';
import { BpDesignSystem } from '../../types';
import { Dayjs } from 'dayjs';
import { Input } from '../Form/Input';
import { getHelperText } from '../Form/HelperText';

import { TextFieldProps } from '@mui/material/TextField';

export type TimePickerProps = BpDesignSystem.PropsWithChildren<
  MuiProps<Dayjs> & {
    error?: boolean;
    errorText?: string;
    helperText?: string;
  }
>;

export const TimePicker: FC<React.PropsWithChildren<TimePickerProps>> = ({
  dataTest,
  className,
  error,
  errorText,
  helperText,
  sx,
  style,
  ...rest
}) => (
  <>
    <MuiComponent
      slots={{
        textField: Input
      }}
      slotProps={{
        actionBar: {
          sx: {
            padding: 3,
            'button.MuiButtonBase-root': {
              width: '100%',
              marginLeft: 0
            }
          }
        },
        desktopPaper: {
          sx: {
            '.MuiMultiSectionDigitalClockSection-root': {
              scrollbarWidth: 'thin'
            }
          }
        },
        ...rest?.slotProps,
        textField: {
          'data-test': dataTest,
          error,
          sx,
          style,
          helperText: !!helperText || !!errorText ? getHelperText(error, helperText, errorText) : undefined,
          ...(rest?.slotProps?.textField ?? {})
        } as unknown as TextFieldProps
      }}
      {...rest}
      className={`time-picker ${className || ''}`}
    />
  </>
);
